export const SUBJECT_API_ROUTES = {
  GET_SUBJECT: "/admin/subject",
  GET_SUBJECT_BY_ID: "admin/subject/:id",
  CREATE_SUBJECT: "/admin/subject",
  UPDATE_SUBJECT: "/admin/subject/:id",
  DELETE_SUBJECT: "/admin/subject/:id",
};
